<template>
  <div class="container">
    <div class="panel panel-default">
      <div class="panel-footer">
        <div class="category">
          <div class="left">
            <a class="category-top" href="javascript:;">导航</a>
            <a class="category-bottom">Navigation</a>
          </div>
          <!-- <div class="right">
                    <van-button style="margin-top: 10px;" color="rgb(7,148,194)" type="primary" size="small">去这里</van-button>
            </div> -->
        </div>
      </div>
      <div class="panel-body" style="padding: 0px" id="staticMap">
        <baidu-map
          class="daohang-map"
          :center="center"
          :zoom="9"
          @ready="handler"
          ak="GL7X2KAWxUP0m5nKqGm1eoGuXQHEM1DY"
          :dragging="false"
        >
          <!-- <bm-geolocation ref="geolocation" @locationSuccess="locationSuccess" anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="false" :autoLocation="autoLocation"></bm-geolocation> -->
          <div
            color="rgb(7,148,194)"
            type="primary"
            size="small"
            class="go"
            @click="daohang"
          >
            <p>导航</p>
          </div>
          <bm-marker
            :position="center"
            :dragging="true"
            animation="BMAP_ANIMATION_BOUNCE"
          >
            <bm-label
              :content="info.DicName + '<div class=jiantou_1></div>'"
              :labelStyle="labelStyle"
              class="gg"
            />
          </bm-marker>
        </baidu-map>
      </div>
    </div>
  </div>
</template>
<script>
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BmGeolocation from "vue-baidu-map/components/controls/Geolocation.vue";
import BmMarker from "vue-baidu-map/components/overlays/Marker";
import BmLabel from "vue-baidu-map/components/overlays/Label";

export default {
  data() {
    return {
      locationPoint: {},
      labelStyle: {
        color: "#fff",
        borderColor: "rgb(234, 85, 23)",
        backgroundColor: "rgb(234, 85, 23)",
        fontSize: "14px",
      },
      autoLocation: true,
      offset: {
        width: -35,
        height: 30,
      },
      centerMap: { lng: 0, lat: 0 },
      // centerMark: {  },
    };
  },
  computed: {},
  components: {
    BaiduMap,
    BmGeolocation,
    BmMarker,
    BmLabel,
  },
  props: {
    center: {
      type: Object,
      require: true,
    },
    info: {
      type: Object,
      require: true,
    },
    region: {
      type: Object,
      require: true,
    },
  },
  watch: {
    region: {
      handler(val, oldVal) {
        this.centerMap.lng = val.Longitude;
        this.centerMap.lat = val.Latitude;
      },
      deep: true,
    },
    info: {
      handler(val, oldVal) {
        // this.centerMark.lng = val.Longitude
        // this.centerMark.lat = val.Latitude
      },
      deep: true,
    },
  },
  mounted() {
    this.$nextTick(()=>{
      
    })
  },
  methods: {
    dragends(e1, e2) {
      console.log(e1);
      console.log(e2);
    },
    daohang() {
      if (!this.locationPoint.hasOwnProperty("lat")) {
        this.$toast.fail("请先点击定位按钮，再导航");
        return;
      }

      let url =
        "http://api.map.baidu.com/direction?origin=latlng:" +
        this.locationPoint.lat +
        "," +
        this.locationPoint.lng +
        "|name:我的位置&destination=latlng:" +
        this.info.Latitude +
        "," +
        this.info.Longitude +
        "|name:" +
        this.info.DicName +
        "&origin_region=" +
        this.locationPoint.city +
        "&destination_region=" +
        this.region.RegionName +
        "&mode=driving&output=html&src=webapp.baidu.openAPIdemo";

      window.location.href = url;
    },
    handler({ BMap, map }) {
      let that = this;
      window.setTimeout(function () {
        that.center.lng = that.info.Longitude;
        that.center.lat = that.info.Latitude;
      }, 800);
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(
        function (r) {
          if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            that.locationPoint = r.point;
            that.locationPoint.city = r.address.city;
          } else {
            that.$toast("failed" + this.getStatus());
          }
        },
        { enableHighAccuracy: true }
      );
    },
    locationSuccess(e) {
      this.locationPoint = e.point;
      this.locationPoint.city = e.addressComponent.city;
    },
    geo() {
      window.navigator.geolocation.getCurrentPosition(function (position) {
        //得到html5定位结果
        var x = position.coords.longitude;
        var y = position.coords.latitude;
        // var x = 116.32715863448607;
        // var y = 39.990912172420714;
        var ggPoint = new BMap.Point(x, y);
        var convertor = new BMap.Convertor();
        var pointArr = [];
        pointArr.push(ggPoint);
        var translateCallback = function (data) {
          console.log(data);
          if (data.status === 0) {
            var marker = new BMap.Marker(data.points[0]);
            map.addOverlay(marker);
            var geoc = new BMap.Geocoder();
            geoc.getLocation(data.points[0], function (rs) {
              console.log(rs.address);
              var label = new BMap.Label(rs.address, {
                offset: new BMap.Size(20, -10),
              });
              marker.setLabel(label); //添加百度label
              map.setCenter(data.points[0]);
            });
          }
        };
        convertor.translate(pointArr, 1, 5, translateCallback);
      });
    },
  },
  created() {},
};
</script>
<style>
.left {
  display: flex;
}
.go {
  position: absolute;
  width: 66px;
  height: 66px;
  right: 16px;
  bottom: 10px;
  background: url("../../assets/images/go.png") no-repeat;
  background-size: 100%;
  line-height: 64px;
  color: #fff;
}
.go p {
  text-align: center;
}
.panel-body {
  position: relative;
}
.daohang-map {
  margin-top: 8px;
}
.gg {
  background-color: #fff;
}
.BMap_noprint {
  display: none;
}
.BMapLabel {
  position: relative;
}
/* .BMapLabel::after {
  content: "";
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 10px solid #ea5517;
  position: absolute;
  top: 50%;
  transform: translateY(100%);
  left: 34%;
} */
.jiantou_1 {
  position: absolute;
  width: 0px;
  height: 0px;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 10px solid #ea5517;
  top: 20px;
  left: 10px;
  overflow: hidden;
  background-position: 0px 0px;
}
</style>